import apiClient from "services/apiClient";

async function grantPermissionToImport(body: any) {
    const res = await apiClient.put(`/admin/imports/grant-permission`, body);
    return res.data;
}

export default grantPermissionToImport;
